module.exports = __webpack_public_path__ + "img/products.1a6b9efc.svg";